import { Alert } from "@mui/material";
import { useAuth } from "../../../auth/AuthContext";
import { UserRole } from "./types";

/** True for a faculty with no grades in the active year (grades are loaded at login). */
export const useFacultyHasNoGrades = (): boolean => {
  const { user } = useAuth();
  return user?.role === UserRole.FACULTY && (user?.grades ?? []).length === 0;
};

/** Shown in place of the grade/section filter when a faculty has no grades assigned. */
export const FacultyNoGradesMessage = () => (
  <Alert severity="info" sx={{ margin: "5px" }}>
    No grades are assigned to you. Please ask the admin to assign grades.
  </Alert>
);
